const BeginnerReseller = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.99379 5.94088V0.331055L0.0500488 14.0885L4.76709 11.5296L7.99379 5.94088Z"
        fill="#87DAFF"
      />
      <path
        d="M4.76709 11.5293L0.0500488 14.0882H7.99379V11.5293H4.76709Z"
        fill="#00C3FF"
      />
      <path
        d="M11.2205 11.5296L15.9375 14.0885L7.99377 0.331055V5.94088L11.2205 11.5296Z"
        fill="#00C3FF"
      />
      <path
        d="M11.2205 11.5293H7.99377V14.0882H15.9375L11.2205 11.5293Z"
        fill="#0096DC"
      />
      <path
        d="M7.99377 11.5292H11.2205L7.99377 5.94043V11.5292Z"
        fill="#87DAFF"
      />
      <path
        d="M4.76709 11.5292H7.9938V5.94043L4.76709 11.5292Z"
        fill="#A5E9FF"
      />
    </svg>
  );
};

export default BeginnerReseller;
